<template>
  <div>
    <div class="simple-card" style="background-color: #0073B7" @mouseover="toggleOverlay(1)" @mouseleave="toggleOverlay(0)" @click.prevent="showRatingQuizSelection">
      <div class="simple-card-overlay" ref="overlay"/>
      <div style="position: relative; z-index:2;">
        <h3 class="simple-card-title" style="margin: 0">{{$t('pages.ratingHistory.ratingQuiz')}}</h3>
        <h4 style="color: white; font-size: 16px">{{$t('pages.exams.ratingResults.numberOfSolvedExercises')}}&nbsp;&nbsp;&nbsp;{{solvedExercises}}/{{allExercises}}</h4>
        <span class="simple-card-content"></span>
        <span class="info-box-icon trophy-icon"><i class="fa fa-trophy"/></span>
      </div>
      <div class="quiz-button-footer" style="z-index: 2">
        <span style="font-size: 14px">{{$t('pages.ratingHistory.startQuiz')}}</span>
      </div>
    </div>
    <div class="modal modal-default fade" style="font-size: 14px" :id="'selectSubgroupsModal'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.ratingHistory.ratingQuiz')}}</h4>
          </div>
          <div class="modal-body">
            <span>{{$t('pages.exams.ratingResults.ratingQuizInfo')}}</span>
            <h4 class="modal-title"  style="margin: 20px 0 10px 0">{{$t('pages.subgroups.selectSubgroups')}}</h4>
            <span style="width: 100%; text-align: center;" v-if="loadingSubgroups">
              <pulse-loader :color="spinnerColor" :size="spinnerSize"></pulse-loader>
            </span>
            <template>
              <div class="form-group">
                <transition-group name="fade">
                  <div v-for="subgroup in filteredSubgroups" :key="subgroup.id">
                    <div :style="'margin-left: ' + (2 * subgroup.nivo) + 'em'">
                      <input v-if="subgroup.list" type="checkbox" :id="subgroup.id" :value="subgroup.id" v-model="izbranePodskupine">
                      <label :for="subgroup.id" @click.prevent="toggleSubgroup(subgroup)">
                        {{ !subgroup.list ? expandedSymbol(subgroup) : '' }} {{ subgroup.name | pickTranslation }}
                      </label>
                      <span
                          v-if="!subgroup.list"
                          @click.prevent="selectAllSbgroupsInTree(subgroup.id, true)"
                          class="text-light-blue pointer"
                      >
                        ({{$t('pages.subgroups.addAll')}})
                      </span>
                      <span
                          v-if="!subgroup.list"
                          @click.prevent="selectAllSbgroupsInTree(subgroup.id, false)"
                          class="text-light-blue pointer"
                      >
                        ({{$t('pages.subgroups.removeAll')}})
                      </span>
                    </div>
                  </div>
                </transition-group>
              </div>
            </template>

            <!--Izbira trajanja-->
            <div class="form-group">
              <label>{{$t('pages.subgroups.selectDuration')}}</label>
              <select class="form-control" v-model="izbranoTrajanje">
                <option value="20">20 min</option>
                <option value="30">30 min</option>
                <option value="45">45 min</option>
              </select>
            </div>

            <!--Admin moznosti-->
            <div class="form-group" v-if="adminView">
              <input type="checkbox" v-model="createQuiz"> {{$t('pages.subgroups.createQuizForOtherUsers')}}
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="createQuiz" class="btn btn-primary pull-right" data-dismiss="modal" @click.prevent="startRatingQuiz">{{$t('pages.subgroups.createQuiz')}}</button>
            <button v-else class="btn btn-primary pull-right" data-dismiss="modal" @click.prevent="startRatingQuiz">{{$t('pages.subgroups.startQuiz')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router/router'
import Rest from '@/services/rest'
import {mapGetters, mapState} from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_FAILED = 3
export default {
  name: 'rating-quiz-button',
  data () {
    return {
      spinnerColor: '#3c8dbc',
      spinnerSize: '15px',
      loadingSubgroups: false,
      subgroupTreeData: null,
      openedSubgroup: null,
      editRuleId: null,
      subgroupArray: [],
      izbranePodskupine: [],
      izbranoTrajanje: 20,
      createQuiz: false,
      allExercises: 0,
      solvedExercises: 0
    }
  },
  props: ['gid', 'sid', 'yid'],
  components: {
    'pulse-loader': PulseLoader
  },
  methods: {
    getNumberOfSolvedExercises () {
      let currentUser = this.$store.getters.getUser
      Rest.request(`GET`, `/rating/getSolvedExercises/` + currentUser.id + '/' + this.gid).then((data) => {
        this.allExercises = data.allExercises
        this.solvedExercises = data.solvedExercises
      })
    },
    toggleOverlay (t) {
      if (t) {
        this.$refs['overlay'].style.opacity = '10%'
      } else {
        this.$refs['overlay'].style.opacity = '0%'
      }
    },
    startRatingQuiz () {
      console.log(this.izbranePodskupine)
      console.log(parseInt(this.izbranoTrajanje))

      let postdata = {
        subgroupIds: this.izbranePodskupine,
        testDuration: this.izbranoTrajanje,
        yearId: this.yid,
        createQuiz: this.createQuiz
      }
      Rest.request(`POST`, `/classExams/ratingQuiz`, postdata).then((data) => {
        let classExamId = data.classExamId
        let examId = data.examId
        if (this.createQuiz) {
          router.push({name: 'editExam', params: {examId: examId}})
        } else {
          Rest.request(`POST`, `/classExams/` + classExamId + `/start`, {}).then((data2) => {
            router.push({name: 'ratingExam', params: {classExamId: classExamId, sid: 'root'}})
          }).catch((err) => {
            console.log(err)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    showRatingQuizSelection () {
      console.log('ee')
      this.loadingSubgroups = true
      this.subgroupArray = []
      window.jQuery('#selectSubgroupsModal').modal('toggle')
      Rest.request(`GET`, `/subgroups/` + this.gid + `/subgroupTreeRating/` + this.sid).then((data) => {
        let tabela = []
        this.treeToArray(tabela, null, data, 0)
        this.subgroupArray = tabela
        this.loadingSubgroups = false
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(
              ['Typeset', window.MathJax.Hub]
          )
          /* var math = window.MathJax.Hub.getAllJax('exerciseStatList')[0]
          window.MathJax.Hub.Queue(['Text', math]) */
        })
      }).catch((err) => {
        console.log(err)
        this.loadingSubgroups = false
      })
    },
    closeAllSubgroups (subgroup) {
      this.subgroupArray.filter((s) => {
        if (s.parent != null) {
          if (s.parent.id === subgroup.id) {
            this.$set(s, 'expanded', false)
            if (s.expanded === false) {
              this.closeAllSubgroups(s)
            }
          }
        }
      })
    },
    expandAllSubgroups (subgroup) {
      var children = this.subgroupArray.filter((s) => {
        if (s.parent != null) {
          if (s.parent.id === subgroup.id) {
            return true
          }
          return false
        }
      })
      if (children.length > 0) {
        children.forEach(s => {
          this.$set(s, 'expanded', true)
          this.expandAllSubgroups(s)
        })
      }
    },
    toggleSubgroup  (subgroup) {
      this.subgroupArray.filter((s) => {
        if (s.parent != null) {
          if (s.parent.id === subgroup.id) {
            this.$set(s, 'expanded', !s.expanded)
            if (s.expanded === false) {
              this.closeAllSubgroups(s)
            }
          }
        }
      })
    },
    expandedSymbol (subgroup) {
      var children = this.subgroupArray.filter((s) => {
        if (s.parent != null) {
          if (s.parent.id === subgroup.id) {
            return true
          }
          return false
        }
      })

      var childrenExpanded = true
      children.forEach(element => {
        if (!element.expanded) {
          childrenExpanded = false
        }
      })

      return childrenExpanded ? '-' : '+'
    },
    selectAllSbgroupsInTree (id, value) {
      var subgroup = this.subgroupArray.filter((s) => {
        if (s.id === id) {
          return true
        }
        return false
      })[0]

      if (value) {
        this.expandAllSubgroups(subgroup)
      } else {
        this.closeAllSubgroups(subgroup)
      }

      for (let i = 0; i < this.subgroupArray.length; i++) {
        if (this.subgroupArray[i].id === id) {
          let j = i + 1
          let nivo = this.subgroupArray[i].nivo
          while (j < this.subgroupArray.length && this.subgroupArray[j].nivo > nivo) {
            if (this.subgroupArray[j].list) {
              if (value) {
                if (!this.izbranePodskupine.includes(this.subgroupArray[j].id)) {
                  this.izbranePodskupine.push(this.subgroupArray[j].id)
                }
              } else {
                let th = this
                this.izbranePodskupine = this.izbranePodskupine.filter(function (el) {
                  return el !== th.subgroupArray[j].id
                })
              }
            }
            j++
          }
          break
        }
      }
    },
    resetSearch () {
      this.sqlsid = ''
      this.stitle = ''
      this.sauthor = ''
      this.ssource = ''
      this.stags = []
      this.stagsExclude = []
      this.slangs = []
      this.stypes = []
      this.sowner = true
      this.spublic = false
    },
    showPreview (tema) {
      this.openedSubgroup = tema
      for (var i = 0; i < this.seznamPodskupin.length; i++) {
        if (this.seznamPodskupin[i].showPreview === true && this.seznamPodskupin[i] !== tema) {
          this.$set(this.seznamPodskupin[i], 'showPreview', !this.seznamPodskupin[i].showPreview)
        }
      }
      this.$set(tema, 'showPreview', !tema.showPreview)
    },
    getOptions () {
      return Rest.request('GET', '/exercises/searchOptions').then((data) => {
        this.options = data
      }).catch((err) => {
        console.log(err)
      })
    },
    toggleDeleteRule () {
      window.jQuery('#modal-beforeDelete').modal('toggle')
    },
    deleteRule () {
      this.$refs.editRules[0].deleteRule(this.editRuleId)
      this.toggleDeleteRule()
      if (this.$refs.previewExercise.length > 0) {
        this.$refs.previewExercise[0].refreshExercises()
      }
    },
    detectMobile () {
      if (navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/webOS/i) ||
          navigator.userAgent.match(/iPhone/i) ||
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/iPod/i) ||
          navigator.userAgent.match(/BlackBerry/i) ||
          navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    treeToArray (tabela, parent, drevo, nivo) {
      tabela.push({
        name: drevo.name,
        id: drevo.id,
        nivo: nivo,
        list: drevo.subgroups.length === 0,
        parent: parent,
        expanded: false
      })
      for (let i = 0; i < drevo.subgroups.length; i++) {
        var p = {
          name: drevo.name,
          id: drevo.id,
          nivo: nivo,
          list: drevo.subgroups.length === 0,
          parent: parent,
          expanded: false
        }
        this.treeToArray(tabela, p, drevo.subgroups[i], nivo + 1)
      }
    },
    closeAllDropdowns (numberOfElements) {
      for (var i = 0; i < numberOfElements; i++) {
        window.jQuery('#dropdownMenuButton-' + i).attr('aria-expanded', false)
        window.jQuery('#dropdown-' + i).removeClass('open')
      }
    },
    editTopic (tema) {
      router.push({name: 'editExam', params: { gid: this.gid, yid: this.yid, sid: this.sid, examId: tema.id }})
    },
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    getStatus (gid, initInterval) {
      Rest.request('GET', `/groups/${gid}/status`).then((data) => {
        this.statusProgress = data.progress
        this.statusType = data.process
        console.log(this.statusType)
        if (this.statusType === 'Recompute group') {
          this.statusMessage = data.message.split('\n')
        } else {
          this.statusMessage = data.message
        }
        if (data.progress == null) {
          initInterval = false
        } else if (data.progress === 100) {
          this.currentStatus = STATUS_INITIAL
          initInterval = false
        } else if (data.progress === -1) {
          this.currentStatus = STATUS_FAILED
          initInterval = false
        } else {
          this.toggleStatus = true
        }
        if (initInterval) {
          this.setStatusInterval(gid)
        }
      }).catch((err) => {
        this.currentStatus = STATUS_FAILED
        console.log(err)
      })
    },
    setStatusInterval (gid) {
      this.toggleStatus = true
      this.statusInterval = setInterval(() => {
        if (this.statusProgress === 100 || this.statusProgress === -1) {
          clearInterval(this.statusInterval)
        }
        this.getStatus(gid, false)
      }, 3000)
    },
    async save () {
      // upload data to the server
      let formData = new FormData(window.jQuery('.uploadForm')[0])
      console.log(formData)
      console.log('neki')
      if (formData) {
        Rest.requestForm('POST', '/upload/group/' + this.gid, formData).then(x => {
          this.currentStatus = STATUS_SAVING
          window.jQuery('#importStructure').modal('toggle')
          this.getStatus(this.gid, true)
          window.jQuery('.uploadForm').find('input:file').val('')
        }).catch(err => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
          alert(this.$t('pages.subgroups.errorMsg') + ((err.responseJSON && err.responseJSON.message) ? ('\n' + err.responseJSON.message) : ('')))
          this.reset()
          window.jQuery('.uploadForm').find('input:file').val('')
        })
      }
    },
    colapseCreateDaily (meSelf) {
      this.isAnthingAlreadyColapsedDaily(meSelf)
      this.$store.commit('toggleCreateDaily')
    },
    colapseEditDaily (meSelf) {
      this.isAnthingAlreadyColapsedDaily(meSelf)
      this.$store.commit('toggleEditDaily')
    },
    colapseCreateSubgroup: function () {
      this.$store.commit('toggleCreateSubgroup')
    },
    isAnthingAlreadyColapsedDaily (meSelf) {
      if (!this.colED && meSelf !== 1) {
        this.$store.commit('toggleEditDaily')
      } else if (!this.colCD && meSelf !== 2) {
        this.$store.commit('toggleCreateDaily')
      }
    }
  },
  mounted () {
    this.reset()
    window.jQuery('#videoModal').on('hidden.bs.modal', function (e) {
      window.jQuery('#videoModal iframe').removeAttr('src')
    })
    this.getNumberOfSolvedExercises()
  },
  computed: {
    ...mapGetters({
      seznamPodskupin: 'getSubgroups',
      dnevneNaloge: 'getDailyChallenges',
      seznamKvizov: 'getExams',
      jeAdmin: 'hasAdminRole'
    }),
    ...mapState({
      defaultGColor: state => state.defaultGColor,
      selectedGroup: state => state.selectedGroup,
      colCS: state => state.adminpanel.exercises.colapseCreateSubgroup,
      colCD: state => state.adminpanel.exercises.colapseCreateDaily,
      colED: state => state.adminpanel.exercises.colapseEditDaily,
      exercisesForProgress: state => state.adminpanel.exercises.dailyChallenges,
      CelotnaNaloga: state => state.exerciseForModal,
      selectedDaily: state => state.adminpanel.exercises.selectedDaily,
      possibleColors: state => state.possibleColors,
      selectedExercises: state => state.exercises.selectedExercises,
      tmpAddExercises: state => state.tmpAddExercises
    }),
    adminView () {
      return this.$route.meta.admin === true
    },

    sqlsid () {
      if (this.sId !== '') {
        return '%' + this.sId + '%'
      } else {
        return ''
      }
    },
    filteredSubgroups () {
      return this.subgroupArray.filter((subgroup) => {
        if (subgroup.expanded) {
          return true
        }
        // Display subgroups with parent set to null
        if (subgroup.parent === null) {
          return true
        }
        // Hide all other subgroups
        return false
      })
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../assets/k6styles/cards';

.simple-card {
  height: 120px;
  cursor: pointer;
}
.simple-card-title {
  color: white;
}
.simple-card-content {
  font-size: 14px;
  color: white;
}
.quiz-button-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 100%;
  height: 25px;
  text-align: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.25);
}
.trophy-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 70px;
  color: rgba(0, 0, 0, 0.22);
  line-height: 0;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// RatingQuizButton.vue?a45ea2ac